import React, { Component, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Moment, { duration } from "moment";
import MicroModal from "micromodal";
import { useDispatch, useSelector } from "react-redux";
import { List, AutoSizer } from "react-virtualized";

import {
  ShowVisibleNextGroup,
  addChatSimult,
  addChat,
  typingadd,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  removeUserMonitoring,
  ShowInfoDisplay,
  AlterScreen,
  EfectBlockUser,
} from "../../actions";
import {
  InitialMonitoring as InitialMonitoringOut,
  SharedScreen,
} from "../../actions/websocket";
import { Tooltip, Popover } from "../../actions/Tippy";
import { Tooltipp, Topover } from "../../actions/Tippy";

import TimeCounterChatInternal from "../TimeCounterChatInternal";

import { ReactComponent as EMCURSO } from "../../build/images/em-curso.svg";
import { ReactComponent as FALARATENDENTE } from "../../build/images/falar-com-atendente.svg";
import { ReactComponent as SIGILOSA } from "../../build/images/sigilosa.svg";
import { ReactComponent as SUSURRO } from "../../build/images/sussurro.svg";
import { ReactComponent as MONITORAR } from "../../build/images/monitorar.svg";
import { ReactComponent as INTERCALAR } from "../../build/images/intercalar.svg";
import { ReactComponent as BLOQUEIO } from "../../build/images/bloqueio.svg";
import { ReactComponent as WHATSAPP } from "../../build/images/whatsapp_icon.svg";
import WHATSAPPICON from "../../build/images/report/whatsapp_icon.png";
import FACEBOOK from "../../build/images/report/facebook_icon.png";
import VOZ from "../../build/images/report/icon_call.png";

var checkFiltro = false;
var keycount = 1;

export function GroupsV2({ screen }) {
  const dispatch = useDispatch();
  const DisplayNextGroup = useSelector((state) => state.displaynextgroup);
  const gruposatd = useSelector((state) => state.groups);
  const usersatd = useSelector((state) => state.agents);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const IPCurrent = useSelector((state) => state.ipcurrent);

  let storageGroup = localStorage.getItem("dashboard_monitoring_group") || [];

  if (storageGroup.length !== 0) {
    storageGroup = storageGroup.split(",").map(Number);
  }

  const [expandGroup, setExpandGroup] = useState([]);
  const [expandUser, setExpandUser] = useState([]);
  const [buttonFilterGrupo, setButtonFilterGrupo] = useState(false);
  const [typeGrupo, setTypeGrupo] = useState(storageGroup);
  const [markAllGroups, setMarkAllGroups] = useState(true);
  const [filterAgent, setFilterAgent] = useState("");
  const [keyGen, setKeyGen] = useState([]);
  const [lsGruposAtd, setLsGruposAtd] = useState([]);
  const [auxKeyGen, setAuxKeyGen] = useState([]);
  const [filterGroup, setFilterGroup] = useState("");
  const [retractExpand, setRetractExpand] = useState("Expandir todos");
  const [lsUsersAtd, setLsUsersAtd] = useState([]);
  const [expandCollapse, setExpandCollapse] = useState("expand");
  const [filtroGrupo, setFiltroGrupo] = useState([]);
  const [actDesb, setActDesb] = useState("1001");
  const [act, setAct] = useState("1");
  const [queueId, setQueueId] = useState(-1);
  const [filter, setFilter] = useState("");
  const [unfold, setUnfold] = useState("unfold_more");
  const [buttonRetract, setButtonRetract] = useState(false);
  const [userOut, setUserOut] = useState(null); // Ou o valor inicial apropriado
  const [horaAction, setHoraAction] = useState(null);
  const [duration, setDuration] = useState(null);
  const [reasonAction, setReasonAction] = useState(null);
  const [visible, setVisible] = useState("");

  function ShowVisible(event) {
    dispatch(ShowVisibleNextGroup(false, false));
  }

  // function DisplayDetails(e) {
  //   e.preventDefault();
  //   setButtonRetract(!buttonRetract);
  //   if (buttonRetract) {
  //     setRetractExpand("Expandir Todos");
  //     setExpandCollapse("expand");
  //     setUnfold("unfold_more");
  //   } else {
  //     setRetractExpand("Retrair Todos");
  //     setExpandCollapse("collapse");
  //     setUnfold("unfold_less");
  //     setExpandGroup([]);
  //     setExpandUser([]);
  //   }
  // }

  function DisplayDetails(e) {
    e.preventDefault();

    if (buttonRetract) {
      setExpandGroup([]);
      setLsUsersAtd([]);
      setRetractExpand("Expandir Todos");
      setExpandCollapse("expand");
      setUnfold("unfold_more");
    } else {
      const allGroupIds = lsGruposAtd.map((group) => group.id);
      setExpandGroup(allGroupIds); // Expande todos
      setLsUsersAtd(
        usersatd.filter((user) => allGroupIds.includes(user.id_grupo))
      );
      setRetractExpand("Retrair Todos");
      setExpandCollapse("collapse");
      setUnfold("unfold_less");
    }

    setButtonRetract(!buttonRetract);
  }

  // function checkExpandGroup(e, idgroup) {
  //   let checkClick = expandGroup.indexOf(idgroup) != -1 ? true : false;
  //   if (!checkClick) {
  //     setExpandGroup(expandGroup.concat([idgroup]));
  //   } else {
  //     setExpandGroup(
  //       expandGroup.filter(function (val) {
  //         return val != idgroup;
  //       })
  //     );
  //   }
  // }

  function checkExpandGroup(e, idgroup) {
    let isExpanded = expandGroup.includes(idgroup);

    setExpandGroup((prevExpandGroup) =>
      isExpanded
        ? prevExpandGroup.filter((val) => val !== idgroup)
        : [...prevExpandGroup, idgroup]
    );
  }

  function checkExpandUser(e, iduser) {
    let checkClick = expandUser.indexOf(iduser) != -1 ? true : false;

    if (!checkClick) {
      setExpandUser(expandUser.concat([iduser]));
    } else {
      setExpandUser(
        expandUser.filter(function (val) {
          return val != iduser;
        })
      );
    }
  }

  function DisplayFilterGrupos(e) {
    setButtonFilterGrupo(!buttonFilterGrupo);
  }

  function getFilterGrupo(e, idgrupo) {
    let typeGrupo = [];
    if (e.target.checked) {
      setTypeGrupo(typeGrupo.concat([idgrupo]));
      typeGrupo = typeGrupo.concat([idgrupo]);
    } else {
      setTypeGrupo(
        typeGrupo.filter(function (val) {
          return val != idgrupo;
        })
      );
      typeGrupo = typeGrupo.filter(function (val) {
        return val != idgrupo;
      });
    }
    localStorage.setItem("dashboard_monitoring_group", typeGrupo);
  }

  function changeAgentGroup(e, teste) {
    const value = e.target.value;
    setFilterAgent(value);

    if (value !== "") {
      setButtonRetract(true);
    } else {
      setButtonRetract(false);
    }

    if (buttonRetract) {
      setRetractExpand("Expandir Todos");
      setExpandCollapse("expand");
      setUnfold("unfold_more");
    } else {
      setRetractExpand("Retrair Todos");
      setExpandCollapse("collapse");
      setUnfold("unfold_less");
      setExpandGroup([]);
    }

    if (e.target.value !== "") {
      setKeyGen([]);
    } else {
      setKeyGen(auxKeyGen);
    }
  }

  const renderPopoverDial = (e, direcao, cliente) => (
    <div className="context-menu" id="drop-em-curso">
      <ul className="context-menu__list">
        <li className="em-curso__item">
          {/* <div className="em-curso__item__img">
                <WHATSAPP/>
            </div>     */}
          <div className="content">
            <div className="content__title">Ocupação: {direcao}</div>
            <div className="content__text">Cliente: {cliente}</div>
          </div>
        </li>
      </ul>
    </div>
  );

  const InitialChatIn = (iduser, displayname, active, ramal) => {
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, false, ramal, datatime)
    );
    dispatch(addChat(iduser, displayname, active, false, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    dispatch(ShowInfoDisplay("Atendentes"));
    dispatch(AlterScreen("Atendentes"));
  };

  const InitialMonitoringIn = (userin, userout, name, line, ramal, screen) => {
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoringOut(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
    if (screen === "Gestor") {
      dispatch(ShowInfoDisplay("Monitorias"));
      dispatch(AlterScreen("Monitorias"));
    }
  };

  const EditTypeMonitoring = (userout, line, screen) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    if (screen === "Gestor") {
      dispatch(ShowInfoDisplay("Monitorias"));
      dispatch(AlterScreen("Monitorias"));
    }
  };

  function InitialChat(e, chatsimult, user) {
    let erro = 0;
    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (parseInt(chat.iduserout) === parseInt(user.iduser)) {
          erro = 1;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        dispatch(ShowInfoDisplay("Atendentes"));
      } else {
        InitialChatIn(parseInt(user.iduser), user.label, true, user.ramal);
      }
    } else {
      InitialChatIn(parseInt(user.iduser), user.label, true, user.ramal);
    }
  }

  function InitialMonitoring(
    e,
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
    screen
  ) {
    let erro = 0;
    let auxline;
    if (monitoringsimult && monitoringsimult.length !== 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          EditTypeMonitoring(userout, line, screen);
        }
      } else {
        InitialMonitoringIn(userin, userout, name, line, ramal, screen);
      }
    } else {
      InitialMonitoringIn(userin, userout, name, line, ramal, screen);
    }
  }

  function showModal(e, userout, action, reasonaction, duration) {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      setUserOut(userout);
      setHoraAction(horaaction);
      setDuration(duration);
      setReasonAction(reasonaction);
      setAct("1001");
      setActDesb("1001");
    } else {
      MicroModal.show("modal__bloqueio");
      setUserOut(userout);
      setAct("1");
    }
  }

  function ActionUserSup(e, modal) {
    let reason = document.getElementById("anotc-add__textarea__input").value;
    dispatch(EfectBlockUser(userOut, act, reason));
    MicroModal.close(modal);
  }

  function ActionUserSupDesbloq(e, modal) {
    let reason = document.getElementById(
      "anotc-add__textarea__input-desb"
    ).value;
    dispatch(EfectBlockUser(userOut, act, reason));
    MicroModal.close(modal);
  }

  function AlterBlockAction(e, value) {
    setAct(value);
    if (value === "1") {
      document.getElementById("logout-atd").checked = false;
    } else {
      document.getElementById("block-atd").checked = false;
    }
  }

  function AlterBlockActionDesb(e, value) {
    setActDesb(value);
    if (value === "1001") {
      document.getElementById("radio-22").checked = false;
    } else {
      document.getElementById("radio-11").checked = false;
    }
  }

  function actionMarkAllGroups(e, groups) {
    let array = [];
    let filters = [];
    setMarkAllGroups(!markAllGroups);
    if (markAllGroups) {
      array = groups;
      for (let i = 0; i < array.length; i++) {
        const myCheckbox = document.getElementById("inputgrupo" + array[i].id);
        myCheckbox.checked = true;
        filters = filters.concat([array[i].id]);
      }
      setTypeGrupo(filters);
      localStorage.setItem("dashboard_monitoring_group", filters);
    } else {
      array = groups;
      for (let i = 0; i < array.length; i++) {
        const myCheckbox = document.getElementById("inputgrupo" + array[i].id);
        myCheckbox.checked = false;
      }
      setTypeGrupo([]);
      localStorage.setItem("dashboard_monitoring_group", []);
    }
  }

  function handleGruposAtd(arrayValue) {
    let gruposAtd = arrayValue;
    let gruposAtd1 = [];
    let gruposAtd2 = [];
    if (gruposAtd.length !== 0) {
      gruposAtd1 = gruposAtd.filter((group) => filter.includes(group.id));
    }

    gruposAtd2 = gruposAtd.filter((agent) => agent.iduser !== InfoUsers.id);

    if (gruposAtd1.length > 0 || gruposAtd2.length > 0) {
      gruposAtd = gruposAtd1.concat(gruposAtd2);
    }

    setLsGruposAtd(gruposAtd);
  }

  function handleUsersAtd(arrayValue) {
    const list = arrayValue || [];
    let usersAtd = [...arrayValue];
    usersAtd = _.filter(list, (agent) => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio,
      ];
      return !_.isEmpty(filterAgent)
        ? _.lowerCase(arrayAgent).indexOf(_.lowerCase(filterAgent)) > -1
        : true;
    });
    setLsUsersAtd(usersAtd);

    usersAtd.map((user) => {
      setFilter(filter.concat([user.id_grupo]));
    });
  }

  function checkUserAtd(user) {
    if (user.status_sip === "AT" && user.razao_bloqueio != "AT") {
      return true;
    } else if (user.status_sip === "LV" && user.status === "AT") {
      return true;
    } else if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
      return true;
    } else if (user.status === "CHND" && user.status_sip != "LV") {
      return true;
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return true;
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return true;
    }

    return false;
  }

  function renderStatus(user) {
    let duracao = "";
    if (user.duration) {
      let arrayCompA = user.duration.split("-");
      let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
      var valorDiferenca = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

      if (parseInt(IPCurrent.difftime) < 0) {
        datatimeCompA = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        datatimeCompA = Moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      }

      let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
        "YYYY/MM/DD HH:mm:ss"
      );
      duracao = Moment(datatimeCompA).diff(dataStatusA, "seconds");
    }
    if (user.status_sip === null || user.status === null) {
      return <div className="item details__text">Status: Deslogado</div>;
    } else if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div>
          <div className="item details__text">Status: Livre</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "AT") {
      return (
        <div>
          <div className="item details__text">Atendimento: Ativo</div>
          <div className="item details__text">Atendendo: {user.speaknum}</div>
          <div className="item details__text">Direção: {user.direcao}</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <div>
          <div className="item details__text">Atendimento: Ativo</div>
          <div className="item details__text">Atendendo: {user.speaknum}</div>
          <div className="item details__text">Direção: {user.direcao}</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div>
          <div className="item details__text">Atendimento: Discando</div>
          <div className="item details__text">Atendendo: {user.speaknum}</div>
          <div className="item details__text">Direção: {user.direcao}</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      return (
        <div>
          <div className="item details__text">Status: Pausado</div>
          <div className="item details__text">Pausa: {user.razao_bloqueio}</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div>
          <div className="item details__text">Status: AfterCallWork</div>
          <div className="item details__text">
            Telefone: {user.razao_bloqueio}
          </div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
      return (
        <div>
          <div className="item details__text">Atendimento: Chamando</div>
          <div className="item details__text">Atendendo: {user.speaknum}</div>
          <div className="item details__text">Direção: {user.direcao}</div>
          <div className="item details__text">
            Duração:{" "}
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </div>
        </div>
      );
    }
  }

  function renderStatusName(user) {
    if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div
          className="status-time pausa-content pausa-btn--livre tippy-default"
          data-tippy-content="media"
        >
          <i className="material-icons">call</i>
          Livre
        </div>
      );
    } else if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return (
        <div
          className="status-time tippy-default pausa-content pausa-btn--pausado"
          data-tippy-content="media"
        >
          <i className="material-icons">timer_off</i>
          Pausado
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div
          className="status-time tippy-default pausa-content pausa-btn--after-call"
          data-tippy-content="media"
        >
          <i className="material-icons">timer</i>
          AfterCallWork
        </div>
      );
    } else if (user.status_sip === "BQ" && user.status === "LV") {
      return (
        <div
          className="status-time tippy-default pausa-content pausa-btn--pausado"
          data-tippy-content="media"
        >
          <i className="material-icons">timer_off</i>
          Pausado
        </div>
      );
    } else if (user.status_sip === "BQ" && user.status === "BQ") {
      return (
        <div
          className="status-time tippy-default pausa-content pausa-btn--pausado"
          data-tippy-content="media"
        >
          <i className="material-icons">timer_off</i>
          Pausado
        </div>
      );
    } else if (user.status_sip === "AT" && user.razao_bloqueio != "AT") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "AT") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status === "CHND" && user.status_sip != "LV") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div
          className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
          data-tippy-content="media"
        >
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} width="10" alt="" />
                  Ativa
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPPICON} width="10" alt="" />
                  Ativa
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">phone_in_talk</i>
                  Ativa
                </>
              );
            }
          })()}
        </div>
      );
    } else if (user.status === null) {
      return (
        <div
          className="status-time pausa-content pausa-btn--inativo tippy-default"
          data-tippy-content="media"
        >
          <i className="material-icons">call_end</i>
          Inativo
        </div>
      );
    } else if (user.status_sip === null && user.status === "LV") {
      return (
        <div
          className="status-time pausa-content pausa-btn--inativo tippy-default"
          data-tippy-content="media"
        >
          <i className="material-icons">call_end</i>
          Inativo
        </div>
      );
    } else {
      return (
        <div
          className="status-time pausa-content pausa-btn--inativo tippy-default"
          data-tippy-content="media"
        >
          <i className="material-icons">call_end</i>
          Inativo
        </div>
      );
    }
  }

  function renderTimeUser(user, duracao) {
    if (user.status === null) {
      return (
        <div className="user-time active">
          <i className="material-icons">query_builder</i>{" "}
          <span className="time">00:00:00</span>
        </div>
      );
    } else if (user.status_sip === null && user.status === "LV") {
      return (
        <div className="user-time active">
          <i className="material-icons">query_builder</i>{" "}
          <span className="time">00:00:00</span>
        </div>
      );
    } else {
      return (
        <div className="user-time active">
          <i className="material-icons">query_builder</i>{" "}
          <span className="time">
            <TimeCounterChatInternal
              horario={parseInt(duracao)}
              key={user.iduser + "_" + user.status_sip}
            />
          </span>
        </div>
      );
    }
  }

  const renderUsers = useMemo(() => {
    return lsGruposAtd.map((group) => ({
      id: group.id,
      users: lsUsersAtd.filter(
        (user) => parseInt(user.id_grupo) === parseInt(group.id)
      ),
    }));
  }, [lsUsersAtd, lsGruposAtd]);

  const renderUser = (user, index, key, style) => {
    let checkAtdUser = checkUserAtd(user);
    let classStatus =
      user.status_sip && user.status
        ? "item-atendentes"
        : "item-atendentes item-atendentes--offline";

    return (
      <div className="details-atendentes" key={key} style={style}>
        <div className={classStatus}>
          <div className="title">
            <div className="title__top">
              <div className="about-user about-user--item">
                <div
                  className="nome"
                  key={user.iduser}
                  onClick={(event) => checkExpandUser(event, user.iduser)}
                >
                  <span className="nome__text nome__text--tec is-poppins">
                    {" "}
                    {user.label}
                  </span>
                </div>
                {renderStatusName(user)}
              </div>

              {(() => {
                let duracao = "";
                if (user.duration) {
                  let arrayCompA = user.duration.split("-");
                  let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
                  var valorDiferenca = parseInt(
                    Math.abs(Math.round(IPCurrent.difftime))
                  );

                  if (parseInt(IPCurrent.difftime) < 0) {
                    datatimeCompA = Moment()
                      .subtract(valorDiferenca, "seconds")
                      .format("YYYY/MM/DD HH:mm:ss");
                  } else {
                    datatimeCompA = Moment()
                      .add(valorDiferenca, "seconds")
                      .format("YYYY/MM/DD HH:mm:ss");
                  }

                  let dataStatusA = Moment(
                    arrayCompA[0],
                    "DD/MM/YYYY HH:mm:ss"
                  ).format("YYYY/MM/DD HH:mm:ss");
                  duracao = Moment(datatimeCompA).diff(dataStatusA, "seconds");
                }
                renderTimeUser(user, duracao);
              })()}

              <div className="actions">
                <div className="em-curso">
                  {(() => {
                    switch (checkAtdUser) {
                      case true:
                        return (
                          <Popover
                            trigger="click"
                            boundary="window"
                            placement="left"
                            multiple={true}
                            interactive={true}
                            content={(e) =>
                              renderPopoverDial(e, user.direcao, user.speaknum)
                            }
                          >
                            <a className="i"></a>
                          </Popover>
                        );

                      default:
                        break;
                    }
                  })()}
                </div>
                <Tooltipp content={"Enviar Mensagem"}>
                  <a
                    href="#"
                    onClick={(event) => InitialChat(event, ChatSimult, user)}
                    className="info tippy-context-menu"
                    data-tippy-placement="right"
                    data-template="drop-em-curso"
                  >
                    <EMCURSO />
                  </a>
                </Tooltipp>
                <Tooltipp content={"Falar com atendente"}>
                  <a
                    href="#"
                    className="info tippy-default"
                    onClick={(e) => {
                      e.stopPropagation();
                      InitialMonitoring(
                        e,
                        InfoUsers.id,
                        user.iduser,
                        user.label,
                        MonitoringSimult,
                        "5",
                        user.ramal,
                        screen
                      );
                    }}
                    data-tippy-theme="light"
                    data-tippy-placement="top"
                    data-tippy-content="Falar com atendente"
                  >
                    <FALARATENDENTE />
                  </a>
                </Tooltipp>
                <Tooltipp content={"Escuta sigilosa"}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.stopPropagation();
                      InitialMonitoring(
                        e,
                        InfoUsers.id,
                        user.iduser,
                        user.label,
                        MonitoringSimult,
                        "1",
                        user.ramal,
                        screen
                      );
                    }}
                    className="info tippy-default"
                    data-tippy-theme="light"
                    data-tippy-placement="top"
                    data-tippy-content="Escuta sigilosa"
                  >
                    <SIGILOSA />
                  </a>
                </Tooltipp>
                <Tooltipp content={"Sussurro"}>
                  <a
                    href="#"
                    className="info tippy-default"
                    onClick={(e) =>
                      InitialMonitoring(
                        e,
                        InfoUsers.id,
                        user.iduser,
                        user.label,
                        MonitoringSimult,
                        "2",
                        user.ramal,
                        screen
                      )
                    }
                    data-tippy-theme="light"
                    data-tippy-placement="top"
                    data-tippy-content="Sussurro"
                  >
                    <SUSURRO />
                  </a>
                </Tooltipp>
                <Tooltipp content={"Intercalar"}>
                  <a
                    href="#"
                    className="info tippy-default"
                    onClick={(e) =>
                      InitialMonitoring(
                        e,
                        InfoUsers.id,
                        user.iduser,
                        user.label,
                        MonitoringSimult,
                        "3",
                        user.ramal,
                        screen
                      )
                    }
                    data-tippy-theme="light"
                    data-tippy-placement="top"
                    data-tippy-content="Intercalar"
                  >
                    <INTERCALAR />
                  </a>
                </Tooltipp>
                <Tooltipp content={"Bloqueio"}>
                  <a
                    onClick={(event) =>
                      showModal(
                        event,
                        user.iduser,
                        user.status_sip,
                        user.razao_bloqueio,
                        user.duration
                      )
                    }
                    href="#"
                    className="info tippy-default"
                    data-tippy-theme="light"
                    data-tippy-placement="top"
                    data-tippy-content="Bloqueio"
                  >
                    <BLOQUEIO />
                  </a>
                </Tooltipp>
              </div>
              <div
                className={
                  expandUser.indexOf(user.iduser) != -1
                    ? "details active"
                    : "details"
                }
              >
                {renderStatus(user)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const renderGroups = ({ index, key, style }) => {
  //   const group = lsGruposAtd[index];
  //   const findUsers = renderUsers.find((g) => g.id === group.id);
  //   const groupUsers = findUsers ? findUsers.users : [];

  //   return (
  //     <div
  //       className="item item--groups"
  //       key={key}
  //       style={{
  //         ...style,
  //         position: "relative",
  //       }}
  //     >
  //       <div
  //         className={
  //           expandGroup.includes(group.id)
  //             ? "inner inner__atendentes active"
  //             : "inner inner__atendentes"
  //         }
  //       >
  //         <div className="title title__atendentes">
  //           <div className="title__top">
  //             <div
  //               className="about-user"
  //               onClick={(event) => checkExpandGroup(event, group.id)}
  //             >
  //               <div className="group is-poppings">{group.name}</div>
  //             </div>
  //             <div className="actions">
  //               <a href="#" className="info">
  //                 <i className="material-icons">more_vert</i>
  //               </a>
  //               <a href="#" className="info">
  //                 <i
  //                   onClick={(event) => checkExpandGroup(event, group.id)}
  //                   className="chevron_right material-icons"
  //                 >
  //                   chevron_right
  //                 </i>
  //               </a>
  //             </div>
  //           </div>
  //         </div>

  //         {/* Virtualizando a lista de usuários */}
  //         {expandGroup.includes(group.id) && (
  //           <AutoSizer disableHeight>
  //             {({ width }) => (
  //               <List
  //                 className="virtualized-user"
  //                 width={width}
  //                 height={Math.min(groupUsers.length * 90, 300)}
  //                 rowCount={groupUsers.length}
  //                 rowHeight={90}
  //                 rowRenderer={({ index, key, style }) => {
  //                   const user = groupUsers[index];
  //                   if (!user) return null;

  //                   return renderUser(user, index, key, style);
  //                 }}
  //               />
  //             )}
  //           </AutoSizer>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };

  const renderGroups = (group, index) => {
    const findUsers = renderUsers.find((g) => g.id === group.id);
    const groupUsers = findUsers ? findUsers.users : [];

    return (
      <div
        className="item item--groups"
        key={index}
        // style={{
        //   ...style,
        //   position: "relative",
        // }}
      >
        <div
          className={
            expandGroup.includes(group.id)
              ? "inner inner__atendentes active"
              : "inner inner__atendentes"
          }
        >
          <div className="title title__atendentes">
            <div className="title__top">
              <div
                className="about-user"
                onClick={(event) => checkExpandGroup(event, group.id)}
              >
                <div className="group is-poppings">{group.name}</div>
              </div>
              <div className="actions">
                <a href="#" className="info">
                  <i className="material-icons">more_vert</i>
                </a>
                <a href="#" className="info">
                  <i
                    onClick={(event) => checkExpandGroup(event, group.id)}
                    className="chevron_right material-icons"
                  >
                    chevron_right
                  </i>
                </a>
              </div>
            </div>
          </div>

          {/* Virtualizando a lista de usuários */}
          {expandGroup.includes(group.id) && (
            <AutoSizer disableHeight>
              {({ width }) => (
                <List
                  className="virtualized-user"
                  width={width}
                  height={Math.min(groupUsers.length * 90, 300)}
                  rowCount={groupUsers.length}
                  rowHeight={90}
                  rowRenderer={({ index, key, style }) => {
                    const user = groupUsers[index];
                    if (!user) return null;

                    return renderUser(user, index, key, style);
                  }}
                />
              )}
            </AutoSizer>
          )}
        </div>
      </div>
    );
  };

  const MyVirtualizedGroups = () => (
    <div className="column-model__body__content">
      <div className="list">
        {lsGruposAtd.map((group, index) => renderGroups(group, index))}
      </div>
    </div>
  );

  // const MyVirtualizedGroups = () => (
  //   <div className="column-model__body__content">
  //     <div className="list">
  //       <AutoSizer>
  //         {({ height, width }) => (
  //           <List
  //             className="virtualized-group"
  //             width={width}
  //             height={height} // Altura da lista
  //             rowCount={lsGruposAtd.length}
  //             rowHeight={44} // Altura de cada grupo
  //             rowRenderer={renderGroups}
  //           />
  //         )}
  //       </AutoSizer>
  //     </div>
  //   </div>
  // );

  useEffect(() => {
    setRetractExpand("Expandir todos");
    setExpandCollapse("expand");
    setQueueId(-1);
    setFilter("");
    setUnfold("unfold_more");
  }, []);

  useEffect(() => {
    if (DisplayNextGroup.length !== 0) {
      if (DisplayNextGroup.displaynextgroup === true) {
        setVisible(" active");
      } else if (
        DisplayNextGroup.displaynextgroup === false ||
        DisplayNextGroup.displaynextgroup === "ocultar"
      ) {
        setVisible(" w-20");
      } else {
        setVisible(" w-20");
      }
    }
  }, [DisplayNextGroup]);

  useEffect(() => {
    if (gruposatd.length !== 0) {
      let gruposAtd = gruposatd.groups;
      let gruposAtd1 = [];
      let gruposAtd2 = [];
      setFiltroGrupo(gruposatd.groups);

      if (typeGrupo !== "") {
        gruposAtd1 = gruposAtd.filter((lsgrupo) =>
          typeGrupo.includes(parseInt(lsgrupo.id))
        );
      }

      if (keyGen !== "") {
        gruposAtd2 = gruposAtd.filter((group) => keyGen.includes(group.id));
      }

      if (gruposAtd1.length > 0 || gruposAtd2.length > 0) {
        gruposAtd = gruposAtd1.concat(gruposAtd2);
      }

      handleGruposAtd(gruposAtd);
    } else {
      handleGruposAtd([]);
    }
  }, [gruposatd, typeGrupo, keyGen]);

  // useEffect(() => {
  //   if (usersatd.length != 0) {
  //     if (!_.isEqual(usersatd, lsUsersAtd)) {
  //       // setLsUsersAtd(usersatd);
  //       handleUsersAtd(usersatd);
  //     }
  //   } else {
  //     handleUsersAtd([]);
  //   }
  // }, [usersatd]);

  useEffect(() => {
    if (expandGroup.length > 0) {
      const filteredUsers = usersatd.filter((user) =>
        expandGroup.includes(user.id_grupo)
      );

      // Evita atualização desnecessária comparando os valores antes de atualizar
      if (!_.isEqual(filteredUsers, lsUsersAtd)) {
        handleUsersAtd(filteredUsers);
      }
    } else {
      handleUsersAtd([]);
    }
  }, [usersatd, expandGroup]);

  let arrayFiltro = [];

  //   useEffect(() => {
  //     const list = lsUsersAtd || [];
  //     let usersAtd = [...lsUsersAtd];
  //     usersAtd = _.filter(lsUsersAtd, (agent) => {
  //       let arrayAgent = [
  //         agent.username,
  //         agent.desc_grupo,
  //         agent.ramal,
  //         agent.razao_bloqueio,
  //       ];
  //       return !_.isEmpty(filterAgent)
  //         ? _.lowerCase(arrayAgent).indexOf(_.lowerCase(filterAgent)) > -1
  //         : true;
  //     });
  //     setLsUsersAtd(usersAtd);

  //     {
  //       usersAtd.map((user) => {
  //         // filter = filter.concat([user.id_grupo])
  //         setFilter(filter.concat([user.id_grupo]));
  //       });
  //     }
  //   }, [lsUsersAtd]);

  // console.log("VEIO AQ1", lsGruposAtd);
  // console.log("VEIO AQ1", gruposatd);
  // console.log("VEIO AQ2", lsUsersAtd);
  // console.log("VEIO AQ2", usersatd);

  return (
    <div className={"column-model small-column" + visible} id="monitoria">
      <div className="column-model__header">
        <div
          className="column-model__header__title"
          onClick={(event) => ShowVisible(event)}
        >
          <button
            type="submit"
            className="column-model__header__title__btn tippy-default"
            data-tippy-theme="light"
            data-tippy-content="Ocultar"
          >
            <i className="material-icons">arrow_back</i>
          </button>
          <div className="text">Monitorar</div>
        </div>

        <div className="column-model__header__select">
          <div
            className={
              buttonFilterGrupo
                ? "select with-icons with-footer-action active"
                : "select with-icons with-footer-action"
            }
          >
            <button
              className="select__btn"
              type="button"
              onClick={(event) => DisplayFilterGrupos(event)}
              data-pausa="Atendimento Presencial Cliente"
            >
              Filtros
              <i className="select__icon material-icons">
                keyboard_arrow_right
              </i>
            </button>
            <div className="options">
              <ul>
                <li key={"99999999999"}>
                  <input
                    type="checkbox"
                    name="inputgrupo9999"
                    id="inputgrupo9999"
                    onChange={(event) =>
                      actionMarkAllGroups(event, filtroGrupo)
                    }
                  />
                  <label htmlFor="inputgrupo9999">
                    {markAllGroups ? "Marcar Todos" : "Desmarcar Todos"}
                  </label>
                </li>
                {filtroGrupo.map((group, index) =>
                  (() => {
                    if (checkFiltro == false) {
                      arrayFiltro.push(parseInt(group.id));
                    }
                    return (
                      <li key={index}>
                        <input
                          type="checkbox"
                          name={"inputgrupo" + group.id}
                          id={"inputgrupo" + group.id}
                          defaultChecked={
                            typeGrupo.findIndex(function (val) {
                              return val === group.id;
                            }) !== -1
                              ? true
                              : false
                          }
                          onChange={(event) =>
                            getFilterGrupo(event, parseInt(group.id))
                          }
                        />
                        <label htmlFor={"inputgrupo" + group.id}>
                          {group.name}
                        </label>
                      </li>
                    );
                  })()
                )}
              </ul>
              <a
                className="btn btn-primary"
                id="apply-filters"
                onClick={(event) => DisplayFilterGrupos(event)}
              >
                Fechar
              </a>
            </div>
          </div>
        </div>
        {/* { (() => {                               
                              if(checkFiltro==false){
                                  this.state.typeGrupo = arrayFiltro;
                                  checkFiltro=true;
                              }
                            }
                      )()       
                    } */}
        <div action="#" className="form-full">
          <div className="full-search">
            <input
              type="text"
              name="client-search"
              id="client-search"
              onChange={(event) => changeAgentGroup(event, "teste")}
              placeholder="Pesquise um operador..."
            />
            <button type="submit" className="full-search__btn">
              <i className="material-icons">search</i>
            </button>
          </div>
        </div>
      </div>

      <div className="column-model__body">
        <a
          className="column-model__body__fold"
          data-action={expandCollapse}
          onClick={(e) => DisplayDetails(e)}
          id="expand-all-group"
        >
          <i className="material-icons">{unfold}</i>
          <p className="text">{retractExpand}</p>
        </a>

        {MyVirtualizedGroups()}
      </div>

      <div
        className="modal micromodal-slide"
        id="modal__bloqueio"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__bloqueio__title"
          >
            <header className="modal__header">
              <h2 className="modal__title" id="modal__bloqueio__title">
                Bloqueio
              </h2>

              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            <div className="modal__header__bottom-line"></div>
            <main
              className="modal__content modal__content--small"
              id="modal__bloqueio__content"
            >
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content--left">
                      <h3 className="modal-box__warning is-poppins">
                        Razão do bloqueio <br />
                      </h3>

                      <p className="modal-box__message">
                        Descreva a razão do bloqueio para o atendente
                      </p>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                    <div className="radio-content radio-content--column">
                      <div className="radio-button">
                        <input
                          type="radio"
                          id="block-atd"
                          name="block-atd"
                          onClick={(event) => AlterBlockAction(event, "1")}
                          defaultChecked={act === "1" ? true : false}
                        />
                        <label htmlFor="block-atd">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Bloquear</div>
                        </label>
                      </div>

                      <div className="radio-button">
                        <input
                          type="radio"
                          id="logout-atd"
                          name="logout-atd"
                          onClick={(event) => AlterBlockAction(event, "2")}
                          defaultChecked={act === "2" ? true : false}
                        />
                        <label htmlFor="logout-atd">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Logout do atendente</div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="anotc-add__textarea">
                      <textarea
                        name="anotc-add__textarea__input"
                        id="anotc-add__textarea__input"
                        className="anotc-add__textarea__input"
                      ></textarea>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                      data-micromodal-close
                    >
                      Cancelar
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button "
                      onClick={(event) =>
                        ActionUserSup(event, "modal__bloqueio")
                      }
                    >
                      OK
                    </a>
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
      <div
        className="modal micromodal-slide"
        id="modal__desbloqueio"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__desbloqueio__title"
          >
            <header className="modal__header">
              <h2 className="modal__title" id="modal__desbloqueio__title">
                Desbloqueio
              </h2>

              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            <div className="modal__header__bottom-line"></div>
            <main
              className="modal__content modal__content--small"
              id="modal__desbloqueio__content"
            >
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content--left">
                      <h3 className="modal-box__warning is-poppins">
                        Razão do bloqueio <br />
                      </h3>

                      <p className="modal-box__message">
                        Descreva a razão do desbloqueio para o atendente
                      </p>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                    <div className="radio-content radio-content--column">
                      <div className="radio-button">
                        <input
                          type="radio"
                          id="radio-11"
                          name="radio-11"
                          onClick={(event) =>
                            AlterBlockActionDesb(event, "1001")
                          }
                          defaultChecked={actDesb === "1001" ? "checked" : ""}
                        />
                        <label htmlFor="radio-11">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Desbloquear</div>
                        </label>
                      </div>

                      <div className="radio-button">
                        <input
                          type="radio"
                          id="radio-22"
                          name="radio-22"
                          onClick={(event) => AlterBlockActionDesb(event, "3")}
                          defaultChecked={actDesb === "3" ? "checked" : ""}
                        />
                        <label htmlFor="radio-22">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Logout do atendente</div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content__form__group__desc">
                      {/* <div className="modal__content__form__group__desc__item">
                                <strong>Bloqueado por:</strong>
                                Gabriel Ferreira
                              </div> */}
                      <div className="modal__content__form__group__desc__item">
                        <strong>Data de bloqueio:</strong>
                        {" " + duration}
                      </div>
                      <div className="modal__content__form__group__desc__item">
                        <strong>Hora de bloqueio:</strong>
                        {" " + horaAction}
                      </div>
                      <div className="modal__content__form__group__desc__item">
                        <strong>Razão do bloqueio:</strong>
                        <span>{" " + reasonAction}</span>
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="anotc-add__textarea">
                      <textarea
                        name="anotc-add__textarea__input"
                        id="anotc-add__textarea__input-desb"
                        className="anotc-add__textarea__input"
                      ></textarea>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                      data-micromodal-close
                    >
                      Cancelar
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button "
                      onClick={(event) => ActionUserSupDesbloq(event)}
                    >
                      OK
                    </a>
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
